import createSelector from '../../createSelector';

const toastsSelector = createSelector('toasts.toasts');

export default toastsSelector;